import { messageTypeEntityName } from '../../../../backend/config/classifiers';
import { buildStorageValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
export function buildMessageTypeValueProvider() {
    return buildStorageValueProvider({
        entityName: messageTypeEntityName,
        label: 'Message Type',
        classifierName: messageTypeEntityName,
        getValues: (client) => client
            .list({
            filter: [{ column: 'status', op: '=', value: 'active' }],
            orderBy: [{ column: 'displayOrder' }, { column: 'name' }],
        })
            .then((result) => result.rows.map((row) => ({
            value: row.columns.name,
            label: row.columns.name,
            description: row.columns.alertInfo,
        }))),
    });
}
